import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button, Switch } from 'antd';
import "./left-slider.scss";
import { NavLink, Outlet, useLocation, matchPath, useNavigate } from "react-router-dom";
import HomeActive from "../../assets/images/home_icon.svg";
import HomeInActive from "../../assets/images/home-inactive.png";
import LoadsActive from "../../assets/images/loads-icon.svg";
import LoadsInActive from "../../assets/images/loads-inactive.svg";
import MyBidsActive from "../../assets/images/my-bids-icon.svg";
import MyBidsInActive from "../../assets/images/my-bids-inactive.svg";
import OrdersActive from "../../assets/images/order-icon.svg";
import OrdersInActive from "../../assets/images/orders-inactive.svg";
import Earnings from "../../assets/images/earnings-icon.svg";
import FulfilmentActive from "../../assets/images/fulfilment-active.svg";
import FulfilmentInactive from "../../assets/images/fulfilment-inactive.svg";
import NotificationActive from "../../assets/images/notification-icon.svg";
import NotificationInActive from "../../assets/images/notification-icon.svg";
import SettingActive from "../../assets/images/settings-icon.svg";
import SettingInActive from "../../assets/images/settings-icon.svg";
import UserIcon from "../../assets/images/user-circle-icon.svg";
import NextArrow from "../../assets/images/sidebar-rightArrow.svg";
import fleetActive from "../../assets/images/fleet-active.svg";
import logoTrukker from "../../assets/images/logo.svg";
import logoAdeed from "../../assets/adeed/images/logo.svg";
import fleetInActive from "../../assets/images/fleet-Inactive.svg";
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { OwnerType,MenuNames } from '../../constants/commonConstants';
import * as localStorageService from "../../service/localStorageService";
import * as homeService from "../../service/home/homeService";
import * as notificationService from "../../service/notification/notificationService";
import notification from '../../service/notification';
import { GuestWarningModal } from '../guest-warning-modal';
import Notifications from '../../pages/notifications/notificationsTab';
import { saveAnalyticalData } from '../../util/analyticalUtility';
import { isAdeed } from '../../constants/brand';
import AdeedLogo from '../adeed-brand/adeed-logo';

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const logo = isAdeed ? logoAdeed : logoTrukker;

const { Header, Sider } = Layout;

const LeftSlider = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { user} = useStore();
  const [collapsed, setCollapsed] = useState(false);
  const [current, setCurrent] = useState('mail');
  const [notificationCount,setNotificationCount]=useState("-")
  const isGuest = localStorageService.getValue("guestMode") === "true";
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);
  const navList = [
    { title: t("LEFT_SIDER_HOME"), url: "home", key: "home", active: <img src={HomeActive} alt="home" />, inActive: <img src={HomeInActive} alt="home" /> },
    { title: t("LEFT_SIDER_LOADS"), url: "loads", key: "loads", active: <img src={LoadsActive} alt="loads" />, inActive: <img src={LoadsInActive} alt="loads" /> },
    { title: t("LEFT_SIDER_MY_BIDS"), urls: ["my-bids/submissions", "my-bids/awarded/*"], key: "my-bids", active: <img src={MyBidsActive} alt="my-bids" />, inActive: <img src={MyBidsInActive} alt="bids" /> },
    { title: t("LEFT_SIDER_FLEET_MANAGEMENT"), url: "view-fleet", key: "view-fleet", active: <img src={fleetActive} alt="fleet" style={{ height: "1.5rem", width: "1.6rem" }} />, inActive: <img src={fleetInActive} alt="fleet" /> },
    { title: t("LEFT_SIDER_ORDERS"), url: "orders", key: "orders", active: <img src={OrdersActive} alt="orders" />, inActive: <img src={OrdersInActive} alt="order" /> },
    ...(user?.userRole != OwnerType.INTERNAL_SOURCE ?[
      { title: t("LEFT_SIDER_EARNINGS"), url: "earnings", key: "earnings", active: <img src={Earnings} alt="earnings" />, inActive: <img src={Earnings} alt="earning" /> }
    ]:[]),
    ...(user?.userRole === OwnerType.INTERNAL_SOURCE ? [{ title: t("LEFT_SIDER_FULFILMENT"), url: "fulfilments", key: "fulfilments", active: <img src={FulfilmentActive} alt="fulfilments" />, inActive: <img src={FulfilmentInactive} alt="fulfilments" /> }]:[])
  ];



  const activeTabStyle = {
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: 'none',
    background: "var(--nav-active-bg, #fff)",
    fontWeight: 'bold',
    fontSize: '13px',
    borderRadius: "10px",
    margin: "5px 0",

  };
  const inactiveTabStyle = {
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: 'none',
    fontSize: '13px',
    width: "100%",
    margin: "5px 0",
    fontStyle: "Pastel Grey_Secondary"
  };

  useEffect(()=>{
    if (!isGuest) {
      getNotificationCount();
    }
  },[])


  const collapsePanel = (isCollapse, type) => {
    setCollapsed(isCollapse);
    props.onCollapse(isCollapse);
  };

  const handleMenuClick = (e) => {
    if (!isGuest) {
      setCurrent(e.key);
      
      if (window.innerWidth < 990) {
        setCollapsed(true);
        collapsePanel(true);
      }
    }
  }
  

  // const handleNavClick = (e, url) => {
  //   debugger
  //   if (isGuest && url !== "loads") {
  //     if(url !== "/notifications"){
  //       GuestWarningModal(navigate)
  //     }
  //     e.preventDefault();
  //     setOpenDrawer(true);
  //     return;
  //   }
  
  //   setCurrent(url);
  
  //   if (window.innerWidth < 990) {
  //     setCollapsed(true);
  //     collapsePanel(true);
  //   }
  // };
  
  const handleNavClick = (e, url) => {
    let rawMenuString=getRawMenuData(url);
    if (isGuest && url !== "loads") {
      if (url !== "notifications") {
        GuestWarningModal(navigate,t);
      }
      e.preventDefault();
      return;
    }
  
    if (url === "notifications") {
      saveAnalyticalData('MENU_CLICK','User opened the menu',rawMenuString,user);
      e.preventDefault(); 
      setOpenDrawer(true); 
      return;
    }
  
    setCurrent(url);
    saveAnalyticalData('MENU_CLICK','User opened the menu',rawMenuString,user);
  
    if (window.innerWidth < 990) {
      setCollapsed(true);
      collapsePanel(true);
    }

  };
  
  const isActiveRoute = (urls) => {
    return urls?.some((url) => matchPath({ path: `/${url}`, end: false }, location.pathname));
  };

  //get notification count
  const getNotificationCount=()=>{
    homeService.getNotificationCount().then(res=>{
      if(res.data?.data?.count!==null&&res.data?.data?.count!==undefined&&res.data?.data?.count!==""){
        setNotificationCount(res.data?.data?.count)
      }
    })
  }

  //handle drawer close event
  const handleNotificationClose=(item)=>{
    if(item){
      readNotification(item);
    }
    setOpenDrawer(false);
  }

  //handle read notification event
  const readNotification=(item)=>{
    //read notification action handle
    if(!item.isRead){
      let payload={
        notificationId:item.id
      }
      notificationService.readNotification(payload).then(res=>{
        getNotificationCount();
      })

    }
  }

  const getRawMenuData=(type)=>{
    switch (type) {
      case "home":
        return MenuNames.HOME;
      case "loads":
        return MenuNames.LOADS;
      case "my-bids/submissions":
          return MenuNames.MY_BIDS;
      case "my-bids/awarded/*":
          return MenuNames.MY_BIDS;
      case "view-fleet":
          return MenuNames.FLEET_MANAGEMENT;
      case "orders":
          return MenuNames.ORDERS;
      case "earnings":
          return MenuNames.EARNINGS;
      case "notifications":
          return MenuNames.NOTIFICATIONS;
      case "setting":
          return MenuNames.SETTINGS;
      case "account":
      return MenuNames.ACCOUNT;
      case "fulfilments":
      return MenuNames.FULFILLMENT;
      default:
        return type;
    }
  }

  return (
    // <>
    // user != null &&
    <div className='side-bar-wrapper'>
      <Sider
        collapsible
        trigger={null}
        // theme="light"
        reverseArrow={false}
        collapsed={collapsed}
        // onCollapse={collapsePanel}
        breakpoint="lg"
        collapsedWidth={window.innerWidth > 900 ? 90 : 0}
        // collapsedWidth="0" 
        width={270}
        className="left-slider"
      >
        <span className='logo-wrapper'>
          {isAdeed ? <AdeedLogo height={36} /> : <img className="logo" src={logo} alt="logo" />}
        </span>
        <hr className='logo-divider' />
        <Menu mode="inline"
          // selectedKeys={[current]}
          selectedKeys={[location.pathname]}
          defaultOpenKeys={['home']}
          onClick={(e) => handleMenuClick(e)}
          className='menu-item-list'
        >
          <span className='menu-span'>{t("LEFT_SIDER_MENU")}</span>
          <div className='menu-div'>
            <div className='menu-first-div'>
              {navList.map((item, index) => {
                return (
                  <NavLink to={item.urls ? item.urls[0] : item.url} key={index}
                    style={({ isActive, isPending }) => {
                      return isActive || (item.urls && isActiveRoute(item.urls)) ? activeTabStyle : inactiveTabStyle;
                    }}
                    onClick={(e) => handleNavClick(e, item.urls ? item.urls[0] : item.url)}
                    className={'menu-items'}
                    children={({ isActive }) => (
                      <Menu.Item style={{ color: "var(--nav-text, #757575)" }} key={index + 1} icon={(isActive || isActiveRoute(item.urls)) ? item.active : item.inActive}>
                        <span className='active-btn'>
                          {item.title}
                          {(isActive || isActiveRoute(item.urls)) && (
                            <img src={NextArrow} alt="next arrow" />
                          )}
                        </span>
                      </Menu.Item>
                    )}>
                  </NavLink>
                )
              })}
            </div>
            <div className='menu-second-div'>
              <span className='menu-span'> {t("LEFT_SIDER_ACCOUNT")}</span>
              <div className={isGuest ? "blur-item disabled-item" : ""}>
              <NavLink to="/notifications" style={({ isActive, isPending }) => {
                return isActive ? activeTabStyle : inactiveTabStyle;
               }}
                onClick={(e) => handleNavClick(e, "notifications")}
                className={'menu-items'}
                children={({ isActive }) => (
                  <div className='menu-title'>
                    <Menu.Item key="notifications" icon={<img src={isActive ? NotificationActive : NotificationInActive} alt="notifications" />} style={{ color: "var(--nav-text, #757575)" }}>
                      <span className='active-btn'>
                        {t("LEFT_SIDER_NOTIFICATIONS")}
                        {isActive && <img src={NextArrow} alt='next arrow' />}
                      </span>
                    </Menu.Item>
                    {notificationCount!==0 && <div className='notify-div'>{notificationCount}</div>}
                  </div>          
                )}
              />
              <Notifications visible={openDrawer} onClose={(item) =>  {
                handleNotificationClose(item)
              }} />
              </div>

              <NavLink to="/setting" style={({ isActive }) => isActive ? activeTabStyle : inactiveTabStyle}
                className='menu-items'
                onClick={(e) => handleNavClick(e, "setting")}
                children={({ isActive }) => (
                  // <div className='menu-title'>
                  <Menu.Item key="setting" icon={<img src={isActive ? SettingActive : SettingInActive} alt="settings" />} style={{ color: "var(--nav-text, #757575)" }}>
                    <span className='active-btn'>
                      {t("LEFT_SIDER_SETTINGS")}
                      {isActive && <img src={NextArrow} alt='next arrow' />}
                    </span>
                  </Menu.Item>
                  // {/* {isActive && <img src={NextArrow} alt='' />} */}
                  // </div>
                )}
              />

              <NavLink to="/account" style={({ isActive }) => isActive ? activeTabStyle : inactiveTabStyle}
                className='menu-items'
                 onClick={(e) => handleNavClick(e, "account")}
                children={({ isActive }) => (
                  <Menu.Item key="account" icon={<img src={isActive ? UserIcon : UserIcon} alt="account" />} style={{ color: "var(--nav-text, #757575)" }}>
                    <span className='active-btn'>
                      {t("LEFT_SIDER_ACCOUNT")}
                      {isActive && <img src={NextArrow} alt='next arrow' />}
                    </span>
                  </Menu.Item>
                )}
              />

            </div>
          </div>
        </Menu>
      </Sider>
    </div>
    // </>
  );
};

export default LeftSlider;
